import React from 'react';
import { MapPin, AlertTriangle } from 'lucide-react';
import { GROUP_META, modelSummary } from '../../utils/clientMap';

const ClientList = ({ clients, groupFor, selectedKey, onSelect }) => {
  if (clients.length === 0) {
    return <p style={{ padding: '16px', color: '#666', fontSize: '14px' }}>Žádný klient neodpovídá filtru.</p>;
  }
  return (
    <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
      {clients.map((c) => {
        const meta = GROUP_META[groupFor(c)];
        const active = c.key === selectedKey;
        return (
          <li key={c.key}>
            <button
              type="button"
              onClick={() => onSelect(c)}
              disabled={!c.location}
              title={c.location ? 'Zobrazit na mapě' : 'Adresa zatím není na mapě'}
              style={{
                display: 'flex', alignItems: 'flex-start', gap: '10px', width: '100%', textAlign: 'left',
                padding: '10px 16px', border: 'none', borderBottom: '1px solid #F0F0F0',
                backgroundColor: active ? '#FFEBEE' : 'transparent', cursor: c.location ? 'pointer' : 'default',
                font: 'inherit', color: 'inherit',
              }}
            >
              <span aria-hidden style={{ width: '12px', height: '12px', borderRadius: '50%', backgroundColor: meta?.color, flexShrink: 0, marginTop: '4px' }} />
              <span style={{ flex: 1, minWidth: 0 }}>
                <span style={{ display: 'block', fontSize: '14px', fontWeight: 600, color: '#333' }}>{c.name}</span>
                <span style={{ display: 'block', fontSize: '12px', color: '#666' }}>
                  {[c.address.city, c.kraj].filter(Boolean).join(' · ')} — {modelSummary(c.machines)}
                </span>
              </span>
              {c.location
                ? <MapPin size={16} color="#999" style={{ flexShrink: 0, marginTop: '2px' }} />
                : <AlertTriangle size={16} color="#F57C00" style={{ flexShrink: 0, marginTop: '2px' }} aria-label="Bez polohy" />}
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default ClientList;
